import {_get, _map, _isEmpty, _isNil, _find, _includes, _filter} from "../../../utils/helpers/zupeeLodash"
import { BOARD_TYPE, IKuk, IPlayerInfo, ITableInfo, PLAYER_NUMBER, TTO_COUNT } from '../types'
import { store } from '../../../store'
import BaseEventProcessor from './base'
import IEventProcessor from './IEventProcessor'
import { getZupeeUserId } from '../../../store/selectors/user'
import { hideGameEndNudge, hideGameStartNudge, hideKukariScore, hideSmokeAnimation, hideTripleSixAnimation, setFinishKillUserToken, setFinishMoveUserToken, setIsSkipTooltipVisible, setKillUserToken, setMoveUserToken, setPlayerSiMap, setRoundTimerStarted, setScoreFlyAnimationConfigForToken, setShowExtraMoveNudge, setUTSData, showGameEndNudge, showGameStartNudge, showKukariScore, showSmokeAnimation, showTripleSixAnimation, startBounceAnimation, startDiceAnimation, startTimeBankTimer, stopBounceAnimation, stopDiceAnimation, stopTimeBankTimer, stopTurnTimer, toggleCoinAnimation, toggleLastMove, updateGameTableInfo, updateTimeBankTimeLeft } from '../../../store/actions/ludoboardActions'
import { getDiceValue, getExtraPointForHomeEnabled, getIsKukariScoreVisible, getIsTtsix, getKilledKukari, getKukarisAtPosition, getLtid, getMovingKukari, getMySeatIndex, getPlayersInfo, getTableId, getTimeBankTimeLeft, getTokenPosition, getTotalPlayers, getTotalTurnTime, getTurnSi } from '../../../store/selectors/ludoboardSelectors'
import { SOUND_KEYS, TST_ROUND_STARTED, TWO_PLAYER_CONFIG } from '../../../components/GamePlayComponents/constant';
import { hideScoreRevealAnimation, showHomeAnimationNx, showScoreRevealAnimation } from '../../../store/actions/ludoboardActions'
import { _every, _isEqual } from '../../../utils/helpers/zupeeLodash'
import EventEmitter from 'events'
import { DTGS, DTGS_EVENTS } from '../../../utils/helpers/constants'
import { parseString } from '../../../utils/helpers/common'
import { getPlayerNumberForSeatIndex } from "../../../utils/helpers/TournamentNXUtils"
import { emit } from "../../../classes/socket/gameplay"
import { isPlayerOnLudoboard } from "../../../classes/socket/helper"
import { NAVIGATION_ROUTES } from "../../../constant"
import { playMusic, playSound } from "../../../classes/sound"
import { navigate } from "../../../utils/helpers/NavigationService"
import { getCurrentRoute } from "../../../navigators/RootNavigation"
import { handleClickCTEventExitTournament, handleClickCTEventGameCompleted, handleClickCTEventWinnerScreen } from "../../../utils/events/events"
const { getState } = store;
const DeviceEventEmitter = new EventEmitter();

export default class LudoNxEventProcessor extends BaseEventProcessor implements IEventProcessor {
  startGameTimerInterval: ReturnType<typeof setInterval> | null
  diceAnimationTimeout: ReturnType<typeof setTimeout> | null
  moveTokenStatus: string
  kukFuture: IKuk | null
  timeout: boolean
  userTimerInterval: ReturnType<typeof setInterval> | null
  localTimeLeft: null | number
  shouldUpdateDvp: boolean
  startAnimationBeginTimeout: ReturnType<typeof setTimeout> | null
  startAnimationEndTimeout: ReturnType<typeof setTimeout> | null
  timeBankCounterInterval: ReturnType<typeof setInterval> | null

  constructor() {
    super()
    this.startGameTimerInterval = null
    this.diceAnimationTimeout = null
    this.moveTokenStatus = 'NOT_STARTED'
    this.kukFuture = null
    this.timeout = false
    this.userTimerInterval = null
    this.localTimeLeft = null
    this.shouldUpdateDvp = true
    this.startAnimationBeginTimeout = null
    this.startAnimationEndTimeout = null
    this.timeBankCounterInterval = null
  }

  // FROM GTI
  processGameTableInfo(tableInfo: any) {
    const myZuid = getZupeeUserId(getState())

    const tst = _get(tableInfo, 'tst')
    const turnSi = _get(tableInfo, 'tos') > -1 ? _get(tableInfo, 'tos') : null

    const mySeatIndex = 0
    let dv = null
    let IsTtsix = null
    let startDice = null
    let bounceAnimation = false
    let isPlayerTableFull = true
    let score = 0
    let timeBankTimeLeft = 0
    let isTimeBankVisible = false

    _map(tableInfo.pi, v => {
      if (_isEmpty(v)) {
        isPlayerTableFull = false
      } else {
        this.parsePlayerSiMap(v.si, v?.ui?.zupeeUserId, mySeatIndex, tableInfo.ms)
        if (turnSi === v.si) {
          score = v.score
          timeBankTimeLeft = v.tbl
          isTimeBankVisible = v.tbtr
          dv = v.dv - 1
          IsTtsix = v.sixcount === 3
        }
        if (v.s === 'RD') {
          startDice = false
          bounceAnimation = true
        }
      }
    })

    const prizePot = _get(tableInfo, 'pv', 0)
    const timeLimitInSecs = _get(tableInfo, 'timeLimitInSecs')
    const boardType = !_isNil(tableInfo.boardType) ? tableInfo.boardType : BOARD_TYPE.DEFAULT_BOARD

    // Get current state
    const currentState = getState();
    const isScoreRevealAnimationVisible = _get(currentState, 'ludoboard.tableInfo.isScoreRevealAnimationVisible', false);
    const isKukariScoreVisible = _get(currentState, 'ludoboard.tableInfo.isKukariScoreVisible', false);
    const coinAnimation = _get(currentState, 'ludoboard.tableInfo.coinAnimation', false);

    updateGameTableInfo({
      _id: "tableInfo._id",
      ltid: tableInfo.ltid,
      gtiAP: tableInfo.ap,
      prizePot,
      gameTimer: _get(tableInfo, 'gameTimer') > 0 ? tableInfo.gameTimer - 1 : _get(tableInfo, 'gameTimer', -1),
      tableStartTime: _get(tableInfo, 'tableStartTime'),
      gameClockUrl: _get(tableInfo, 'gameClockUrl'),
      pi: tableInfo.pi || [],
      pgi: _get(tableInfo, 'pgi[0]', {}), // get profile pic and username from here
      tst,
      shareCode: tableInfo.shareCode,
      totalPlayers: tableInfo.ms,
      bounceAnimation,
      startDice,
      showTurnTimer: true,
      leftPlayers: _get(tableInfo, 'leftPlayers', []),
      stt: _get(tableInfo, 'stt') || 15,
      totalTimeBankTime: _get(tableInfo, 'TBT'),
      timeBankTimeLeft,
      turnSi,
      timeLeft: _get(tableInfo, 'Timer', 0), // for setinterval
      dv,
      IsTtsix,
      poolDistribution: _get(tableInfo, 'poolDistribution'),
      quickGuide: _get(tableInfo, 'quickGuide'),
      entryFee: _get(tableInfo, 'bv', 0),
      roundNo: tableInfo?.roundNo,
      boardType,
      timeLimitInSecs,
      movesLeft: _get(tableInfo, 'movesLeft', 0),
      score,
      extraPointForHomeEnabled: _get(tableInfo, 'extraPointForHomeEnabled', false),
      textForGameFeed: _get(tableInfo, 'textForGameFeed'),
      isTimeBankVisible,
      turnCount: _get(tableInfo, 'played_tc'),
      enableHomeAnimation: _get(tableInfo, 'enableHomeAnimation'),
      maxWinners: _get(tableInfo, 'maxWinners'),
      mySeatIndex: null,
      isOpenShareModal: false,
      coinAnimation,
      smokeAnimation: false,
      startGameIcon: false,
      gameStartCountdown: 0,
      finalMovePlayers: null,
      finishingGame: false,
      pointsAnimation: false,
      tripleSixAnimation: false,
      payoutDistribution: {},
      showProfileModal: false,
      showInternetIcon: false,
      internetConnectivity: '',
      showGameTimeNudge: false,
      showGameStartNudge: false,
      showSkipBox: false,
      showWrongTurnAlert: false,
      skipSi: null,
      ftcpData: {
        maxCurrentUserTurnAnimation: 0,
        maxOtherUserTurnAnimation: 0,
        isVoiceOverEnabled: false
      },
      currentPlayerTurnCount: null,
      kukariMoveConfig: null,
      scoreFlyAnimationConfig: null,
      showTakeHomeNudge: false,
      roundNumber: null,
      gameTimeLimitText: null,
      ttoScreenData: null,
      skipCountForNudge: null,
      tokenCutCN: [],
      reachHomeCN: [],
      safeCN: [],
      isPrizepoolTooltipVisible: false,
      isTNCBSVisible: false,
      playedTc: 0,
      showGameEndNudge: false,
      isKukariScoreVisible,
      isScoreRevealAnimationVisible,
      showExtraMoveNudge: false,
      isSkipTooltipVisible: false
    })
    playMusic()
  }

  processCollectBootValue() {
    console.log('Processing collect boot value');
    // First ensure the animation state is true
    updateGameTableInfo({
      ...getState().ludoboard.tableInfo,
      coinAnimation: true
    });
    setTimeout(() => {
      playSound(SOUND_KEYS.BOOT_VALUE_SELECT);
    }, 500);
  }

  handleCoinAnimationEnd() {
    
    // Set coin animation to false
    updateGameTableInfo({
      ...getState().ludoboard.tableInfo,
      coinAnimation: false
    });
    
    // Show game start nudge
    showGameStartNudge();
    
    // First timeout - hide game start nudge and show score reveal
    setTimeout(() => {
      hideGameStartNudge();
      showScoreRevealAnimation();
      
      // Second timeout - hide score reveal and show kukari score
      setTimeout(() => {
        hideScoreRevealAnimation();
        showKukariScore();
        
        // Third timeout - hide kukari score
        setTimeout(() => {
          hideKukariScore();
        }, 1500);
      }, 2000);
    }, 2000);
  }

  validateTableOnUTS(tbData: Array<IPlayerInfo>) {
    const pi = getPlayersInfo(getState())
    const tbid = getTableId(getState())

    let isStateChanged = false

    _every(pi, pInfo => {
      const data = _find(tbData, { si: pInfo.si }) || ({} as IPlayerInfo)
      if (!_isEqual(pInfo.dvp, data.dvp)) {
        isStateChanged = true
        return false
      }
      return true
    })

    if (isStateChanged) {
      this.shouldUpdateDvp = true
      DeviceEventEmitter.emit(DTGS, { en: DTGS_EVENTS, data: parseString({ en: 'GTI', data: { tbid } }) })

      return _map(pi, pInfo => {
        const data = _find(tbData, { si: pInfo.si }) || ({} as IPlayerInfo)
        return { ...pInfo, dvp: data.dvp }
      })
    }
  }

  //FROM UTS
  processUserTurnStarted(data:any) {
    if (this.diceAnimationTimeout) {
      clearTimeout(this.diceAnimationTimeout)
      this.diceAnimationTimeout = null
    }
    if (this.startGameTimerInterval) {
      clearInterval(this.startGameTimerInterval)
      this.startGameTimerInterval = null
      setRoundTimerStarted({ startGameIcon: false, gameStartCountdown: 0 })
    }

    const newPi = this.validateTableOnUTS(_get(data, 'tbdata'))

    const totalTurnTime = getTotalTurnTime(getState())

    this.kukFuture = null
    this.moveTokenStatus = 'NOT_STARTED'

    const state = {
      turnSi: data.si,
      timeLeft: totalTurnTime,
      dv: data.dv,
      startDice: null,
      bounceAnimation: false,
      movingKukari: null,
      killedKukari: null,
      ...(this.shouldUpdateDvp && newPi ? { pi: newPi } : {}),
      IsTtsix: data.IsTtsix,
      tst: TST_ROUND_STARTED,
      gameTimer: _get(data, 'gameTimer') > 0 ? _get(data, 'gameTimer') - 1 : _get(data, 'gameTimer', -1),
      showTurnTimer: true,
      movesLeft: data?.movesLeft,
      turnCount: data?.played_tc,
      score: {}
    }

    if (data.extraTurn) {
      setShowExtraMoveNudge(true)
      setTimeout(() => {
        setShowExtraMoveNudge(false)
      }, 1600)
    }

    if (state.turnSi === getMySeatIndex(getState())) {
      // logger(TAG_NAMES.LS_GAMEPLAY, 'UTS for self')
      const myTbData = _find(_get(data, 'tbdata', []), pi => pi.si === data.si)

      if (myTbData?.score !== undefined) {
        state.score = myTbData.score
      }
    }

    setUTSData(state)

    this.shouldUpdateDvp = false
  }

  processTurnUserTimeout(data:any, disconnectCount: number) {
    setIsSkipTooltipVisible(true)
  }

  // processTurnUserTimeout(data, disconnectCount: number) {
  //   setIsSkipTooltipVisible(true)
  // }
  // processTurnUserTimeout(data, disconnectCount: number) {
  //   if (getBoardType(getState()) === BOARD_TYPE.TRIO_BOARD) {
  //     this.turnUserTimeout3Player(data, disconnectCount)
  //   }
  //   const { si, TCount } = data
  //   const mySeatIndex = getMySeatIndex(getState())
  //   playSkipSound(TCount, si === mySeatIndex)
  //   if (si === mySeatIndex) {
  //     if (TCount === TTO_COUNT.THREE) {
  //       this.timeout = true
  //     }
  //     setSkipCountForNudge(TCount)
  //     setTimeout(() => {
  //       setSkipCountForNudge(null)
  //       setShowSkipBox(si)
  //     }, 1600)
  //     setTimeout(() => {
  //       setPlayerTCount(si, TCount)
  //     }, 2000)
  //     setTimeout(() => {
  //       hideSkipBox()
  //       if (TCount === TTO_COUNT.THREE) {
  //         logger(TAG_NAMES.LS_GAMEPLAY, '3TTO occurred', {
  //           isAddEvent: true,
  //           isLogDataToFile: true,
  //           data: { disconnectCount }
  //         })
  //         DeviceEventEmitter.emit(DTGS, { en: DTGS_EVENTS.DESTROY })
  //         this.handleThreeTurnTimeout()
  //       }
  //     }, 3100)
  //   } else {
  //     setPlayerTCount(si, TCount)
  //     setShowSkipBox(si)
  //     setTimeout(() => {
  //       hideSkipBox()
  //     }, 1500)
  //   }
  // }

  processAnimateDice(eventType: 'click' | 'socket') {
    const currTurnSi = getTurnSi(getState())

    if (eventType === 'socket' && currTurnSi === getMySeatIndex(getState())) {
      return
    }

    startDiceAnimation()
    const isTtsix = getIsTtsix(getState())

    this.diceAnimationTimeout = setTimeout(() => {
      if (currTurnSi === getTurnSi(getState())) {
        if (!isTtsix) {
          startBounceAnimation()
        } else {
          showTripleSixAnimation()
          setTimeout(() => {
            hideTripleSixAnimation()
          }, 1600)
        }
        stopDiceAnimation()
      }
    }, 500)
  }

  processTimeBankLeft(data:any) {
    const { state, si, tbl } = data

    if (si === getMySeatIndex(getState())) {
      if (state === 'START') {
        startTimeBankTimer(tbl)
      } else if (state === 'END') {
        stopTimeBankTimer(tbl)
      }
    }
  }

  processLeaveTable(data: any) {
    if (isPlayerOnLudoboard()) {
     if(data?.isLeft) {
      handleClickCTEventExitTournament()
     }
      navigate(NAVIGATION_ROUTES.WINNER_SCREEN, {state: { ltid: getLtid(getState()), ...data }, replace: true} )
      handleClickCTEventWinnerScreen();
    }
  }

  processWinnerDeclared(data: any) {
    console.log("getCurrentRoute()?.currentPath ", getCurrentRoute()?.currentPath)
    if (data) {
      handleClickCTEventGameCompleted(); // need a property to determine whether player left the table or not.
      if (getCurrentRoute()?.currentPath === NAVIGATION_ROUTES.GAMEPLAY) {
        showGameEndNudge()
        setTimeout(() => {
          hideGameEndNudge()
          navigate(NAVIGATION_ROUTES.WINNER_SCREEN, {state: { ltid: getLtid(getState()), ...data }, replace: true})
          handleClickCTEventWinnerScreen();
        }, 2000)
      }
    }
  }

  processLastMove(data: any) {
    toggleLastMove(_get(data, 'playerNames', []))
    setTimeout(() => {
      toggleLastMove()
    }, 3000)
  }

  moveUserToken(moveSi: number, tokenIndex: number, finalPosition: number, kuk?: IKuk) {
    this.cancelUserTimerSounds()
    this.kukFuture = kuk || null
    if (this.moveTokenStatus === 'RUNNING') {
      return
    }

    if (this.moveTokenStatus === 'FINISHED') {
      this.killUserToken()
      return
    }

    this.moveTokenStatus = 'RUNNING'
    const totalPlayers = getTotalPlayers(getState())
    const mySeatIndex = getMySeatIndex(getState())

    if (_isNil(mySeatIndex)) {
      return
    }

    setMoveUserToken({
      playerNumber: getPlayerNumberForSeatIndex(totalPlayers, mySeatIndex, moveSi),
      tokenIndex,
      finalPosition
    })
  }

  killUserToken() {
    if (!this.kukFuture) {
      return
    }

    const { si, kukari } = this.kukFuture

    const kukPlayerNumber = getPlayerNumberForSeatIndex(getTotalPlayers(getState()), getMySeatIndex(getState()), si)

    console.log("kukPlayerNumber", JSON.stringify(kukPlayerNumber));

    showSmokeAnimation({
      tokenPosition: getTokenPosition(null, kukPlayerNumber, kukari, getState()) || 0,
      playerNumber: kukPlayerNumber
    })

    setTimeout(() => {
      if (this.kukFuture) {
        const { si, kukari } = this.kukFuture

        const kukPlayerNumber = getPlayerNumberForSeatIndex(getTotalPlayers(getState()), getMySeatIndex(getState()), si)
        const finalPosition = getTokenPosition(null, kukPlayerNumber, kukari, getState()) || 0
        setScoreFlyAnimationConfigForToken(kukPlayerNumber, true, finalPosition, 0, true)

        console.log("finalPosition", JSON.stringify(finalPosition))

        setKillUserToken({
          playerNumber: kukPlayerNumber,
          tokenIndex: kukari
        })
      }
    }, 600)

    setTimeout(() => {
      hideSmokeAnimation()
    }, 1000)
  }

  finishMoveUserToken(initialPosition: number) {
    if (this.moveTokenStatus !== 'RUNNING') {
      return
    }
    this.moveTokenStatus = 'FINISHED'
    this.killUserToken()
    const { playerNumber, tokenIndex, finalPosition } = getMovingKukari(getState()) || {}

    if (_isNil(playerNumber) || _isNil(tokenIndex) || _isNil(finalPosition)) {
      return
    }

    // const boardType = getBoardType(getState())
    const boardConfig = TWO_PLAYER_CONFIG

    if (_isNil(boardConfig)) {
      return
    }

    const si = _get(getState(), `ludoboard.tableInfo.${playerNumber}`)
    const safePositions = boardConfig.SAFE_POSITIONS
    const startPosition = boardConfig.START_POSITIONS[playerNumber as PLAYER_NUMBER]

    if (_isNil(startPosition)) {
      return
    }

    const posOnBoard = (finalPosition + startPosition) % boardConfig?.OUTER_PATH_LENGTH

    if (finalPosition <= boardConfig?.OUTER_PATH_LENGTH - 2 && _includes(safePositions, posOnBoard)) {
      playSound(SOUND_KEYS.SAFE_PLACE)
    }

    if (finalPosition === boardConfig?.PATH_FINAL_INDEX) {
      const playersInfo = getPlayersInfo(getState())
      const mySeatIndex = getMySeatIndex(getState())

      const myPlayersInfo = _find(playersInfo, pInfo => pInfo.si === mySeatIndex)

      const homeCount = _filter(myPlayersInfo?.dvp, pos => pos === 56).length + 1

      showHomeAnimationNx(homeCount)
      // playExtra56Score(playerNumber === PLAYER_NUMBER.ONE)
    }

    if (this.kukFuture) {
      setTimeout(() => {
        setFinishMoveUserToken(si, tokenIndex, finalPosition);  
      }, 600)
    } else {
      if (getKukarisAtPosition(posOnBoard, getState())) {
        playSound(SOUND_KEYS.SAFE_PLACE)
      }
      if (getExtraPointForHomeEnabled(getState()) && finalPosition === boardConfig?.PATH_FINAL_INDEX) {
        setScoreFlyAnimationConfigForToken(playerNumber, true, undefined, undefined, true)
      }
      setFinishMoveUserToken(si, tokenIndex, finalPosition)
    }
  }

  finishKillUserToken(initialPosition: number) {
    const { playerNumber, tokenIndex } = getKilledKukari(getState()) || {}
    const si = _get(getState(), `ludoboard.tableInfo.${playerNumber}`)
    if (!_isNil(playerNumber) && !_isNil(si)) {
      setFinishKillUserToken(si, tokenIndex, 0)
    }
  }

  processMoveUserKukari(data: { si: any; kukari: any; fp: any; kuk: any }) {
    const { si, kukari, fp, kuk } = data

    if (si !== getMySeatIndex(getState())) {
      if (this.diceAnimationTimeout) {
        clearTimeout(this.diceAnimationTimeout)
        stopDiceAnimation()
      }
    }
    this.moveUserToken(si, kukari, fp, kuk)
  }

  handleMoveTokenClick(tokenIndex: number) {
    const moveSi = getMySeatIndex(getState()) || 0
    const currentPosition = _get(getState(), `ludoboard.tableInfo.pi.${moveSi}.dvp.${tokenIndex}`) || 0
    const diceValue = getDiceValue(getState()) || 0

    stopBounceAnimation()
    stopTimeBankTimer()

    emit(parseString({ en: 'MUK', data: { wk: false, kukari: tokenIndex } }))

    if (_isNil(this.localTimeLeft) || this.localTimeLeft > 1) {
      stopTurnTimer()
      this.moveUserToken(moveSi, tokenIndex, currentPosition + diceValue + 1)
    }
  }

  handleUserTimerSounds(timeLeft: number, totalTurnTime: number, percentageToStartSoundAt: number = 0.5) {
    if (this.userTimerInterval) {
      clearInterval(this.userTimerInterval)
      this.userTimerInterval = null
    }
    this.localTimeLeft = timeLeft
    this.userTimerInterval = setInterval(() => {
      if (_isNil(this.localTimeLeft) || this.localTimeLeft < 0) {
        if (this.userTimerInterval) {
          clearInterval(this.userTimerInterval)
          this.userTimerInterval = null
        }
        return
      }
      const newTimeLeft = this.localTimeLeft - 1

      if (newTimeLeft >= 1 && newTimeLeft <= (totalTurnTime - (percentageToStartSoundAt * totalTurnTime))) {
        playSound(SOUND_KEYS.TURN_TIMER)
      }
      this.localTimeLeft = newTimeLeft
    }, 1000)
  }

  // activateTimeBankCounter() {
  //   this.deActivateTimeBankCounter()
  //   this.timeBankCounterInterval = setInterval(() => {
  //     updateTimeBankTimeLeft(getTimeBankTimeLeft(getState()) - 1)
  //   }, 1000)
  // }

  // deActivateTimeBankCounter() {
  //   clearInterval(this.timeBankCounterInterval)
  //   this.timeBankCounterInterval = null
  // }

  activateTimeBankCounter() {
    this.deActivateTimeBankCounter()
    this.timeBankCounterInterval = setInterval(() => {
      updateTimeBankTimeLeft(getTimeBankTimeLeft(getState()) - 1)
    }, 1000)
  }

  deActivateTimeBankCounter() {
    if (this.timeBankCounterInterval) {
      clearInterval(this.timeBankCounterInterval)
      this.timeBankCounterInterval = null
    }
  }

  cancelUserTimerSounds() {
    if (this.userTimerInterval) {
      clearInterval(this.userTimerInterval)
      this.userTimerInterval = null
    }
  }

  clearAllTimeoutsAndIntervals() {
    if (this.startGameTimerInterval) clearInterval(this.startGameTimerInterval)
    if (this.userTimerInterval) clearInterval(this.userTimerInterval)
    if (this.startAnimationBeginTimeout) clearTimeout(this.startAnimationBeginTimeout)
    if (this.startAnimationEndTimeout) clearTimeout(this.startAnimationEndTimeout)
    this.cancelUserTimerSounds()
  }

  handleUserTurnEnded() {
    stopBounceAnimation()
    playSound(SOUND_KEYS.TIME_UP)
  }

  handleOtherPlayerTokenClick(playerNumber: PLAYER_NUMBER, score: number) {
    if (playerNumber !== PLAYER_NUMBER.ONE && score > 0 && !getIsKukariScoreVisible(getState())) {
      showKukariScore()
      setTimeout(() => {
        hideKukariScore()
      }, 6000)
    }
  }
  
  parsePlayerSiMap(si: number, zuid: number, selfSi?: number, ms?: number) {
    // const myZuid = getZupeeUserId(getState())
    const myZuid = 164007819437377
    const totalPlayers = ms || getTotalPlayers(getState())
    const mySeatIndex = !_isNil(selfSi) ? selfSi : getMySeatIndex(getState())

    // Ideally we receive JT event for self first then GTI and then JT for other users
    // it will run very first time and then from next JT else it will run

    if (zuid === myZuid) {
      setPlayerSiMap(PLAYER_NUMBER.ONE, si)
    } else if (!_isNil(mySeatIndex) && !_isNil(totalPlayers)) {
      setPlayerSiMap(getPlayerNumberForSeatIndex(totalPlayers, mySeatIndex, si), si)
    }
  }
}
